import React from "react";
import styled from "styled-components";
import PlaceholderImg from "../../assets/images/hatena.svg";

const get_img_width = (image_size, default_width) => {
  if (image_size.width < 1 || image_size.height < 1) {
    return "auto";
  }
  const ratio = image_size.height / image_size.width;
  if (ratio < 1.0) {
    return "auto";
  }
  return default_width;
};
const get_img_height = (image_size, default_height) => {
  if (image_size.width < 1 || image_size.height < 1) {
    return "auto";
  }
  const ratio = image_size.height / image_size.width;
  if (ratio > 1.0) {
    return "auto";
  }
  return default_height;
};

const StyledImage = styled.img`
  width: ${(props) => get_img_width(props.image_size, props.default_width)};
  height: ${(props) => get_img_height(props.image_size, props.default_height)};

  @media (max-width: 450px) {
    width: ${(props) =>
      get_img_width(props.image_size, props.default_mobile_width)};
    height: ${(props) =>
      get_img_height(props.image_size, props.default_mobile_height)};
  }
`;

const Image = (props) => {
  const [image_size, set_image_size] = React.useState({ width: 0, height: 0 });
  const handle_image_load = (e) => {
    set_image_size({
      width: e.target.width,
      height: e.target.height,
    });
  };
  const placeholder = props.placeholder || PlaceholderImg;
  return (
    <StyledImage
      src={props.src || placeholder}
      onLoad={handle_image_load}
      image_size={image_size}
      default_width={props.default_width}
      default_height={props.default_height}
      default_mobile_width={props.default_mobile_width}
      default_mobile_height={props.default_mobile_height}
    />
  );
};

export default Image;
